let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fyePX")).then(() => parcelRequire('lfXxs'));